import request from '@/utils/request'

// 微信登录返回code
export function webWxLogin(data) {
    return request({
        url: '/api/third-login/webWxLogin',
        method: 'get',
        params: data,
    })
}

//手机注册
export function appRegisterLogin(data) {
    return request({
        url: '/api/third-login/appRegisterLogin',
        method: 'post',
        data,
    })
}

// 支付宝登录返回code
export function webZfbLogin(data) {
    return request({
        url: '/api/third-login/webZfbLogin',
        method: 'get',
        params: data,
    })
}